<template>
  <div class="h-64 rounded-md">
    <l-map
      v-if="showMap"
      :zoom="zoom"
      :center="center"
      :options="mapOptions"
      style="height: 100%"
      @update:center="centerUpdate"
      @update:zoom="zoomUpdate"
      :bounds="markerBounds"
      :padding="[30, 30, 30, 30]"
    >
      <l-tile-layer :url="url" :attribution="attribution" />
      <l-marker :lat-lng="withPopup" :draggable="marker.draggable">
        <l-popup>
          <div>Huidige accommodatie</div>
        </l-popup>
      </l-marker>

      <l-marker
        v-for="acc in accommodatiesWithLatLng"
        v-bind:key="acc.id"
        :lat-lng="acc.latlon"
        :draggable="marker.draggable"
      >
        <l-popup>
          <div>{{ acc.naam }}</div>
        </l-popup>
      </l-marker>
    </l-map>
  </div>
</template>

<script>
import { latLng } from "leaflet";
import { LMap, LTileLayer, LMarker, LPopup } from "vue2-leaflet";

export default {
  name: "Map",
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LPopup
  },
  props: ["latlon", "accommodaties"],
  data() {
    return {
      zoom: 16,
      center: latLng(this.latlon[0], this.latlon[1]),
      url: "https://{s}.tile.openstreetmap.fr/hot/{z}/{x}/{y}.png",
      attribution:
        '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      currentZoom: 16,
      currentCenter: this.withPopup,
      showParagraph: false,
      mapOptions: {
        zoomSnap: 0.5
      },
      marker: {
        draggable: false
      },
      showMap: true
    };
  },
  computed: {
    withPopup: function() {
      return latLng(this.latlon[0], this.latlon[1]);
    },
    accommodatiesWithLatLng: function() {
      return this.accommodaties.map(acc => ({
        ...acc,
        latlon: latLng(acc.latlon[0], acc.latlon[1])
      }));
    },
    markerBounds: function() {
      return [
        this.accommodatiesWithLatLng.map(acc => acc.latlon),
        this.withPopup
      ];
    }
  },
  methods: {
    zoomUpdate(zoom) {
      this.currentZoom = zoom;
    },
    centerUpdate(center) {
      this.currentCenter = center;
    }
  }
};
</script>
